/***
**Module Name: Footer 
 **File Name :  Footer.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 27 2022
 **Last modified on: Dec 27 2022
 **Description : contains Footer component details.
 ***/
import React from "react";
import { useNavigate  } from "react-router-dom";


// import { Link } from "react-router-dom";


import * as Config from "./../../constants/Config";


const Footer = (props) => {
  const navigate = useNavigate();
 
  // console.log("props",props.id);
  const handlemenuclick = (e,path,id) => {
    window.localStorage.setItem("menuCode",id);
    navigate(path);
  }
  return (
   <>
  <footer
    id="footer"
    className={`footer ${props.moreInfoCls || ""}`}
  >
    <div id="footer-container-fluid" className="container-fluid">
      <div id="footer-container" className="footer-container">
        <ul id="footer-links" className="footer-links">
          {props.menus &&
            props.menus.length > 0 &&
            props.menus.map(function (item, i) {
              let pathlink = "/" + item.route;
              return item.type === "footermenu" ? (
                <li
                  key={i}
                  id={`footer-menu-item-${item.menuid}`}
                  className="footer-menu-item"
                >
                  <a
                    id={`footer-menu-link-${item.menuid}`}
                    className="nav-link active"
                    href="#"
                    onClick={(e) => handlemenuclick(e, pathlink, item.menuid)}
                  >
                    {item.menu}
                  </a>
                </li>
              ) : (
                ""
              );
            })}
        </ul>
       <p id="footer-para" className="footer-para">
  &copy; {new Date().getFullYear()} Orasi Media.
</p>
      </div>
    </div>
  </footer>

  <a
    id="back-to-top"
    href="#"
    className="back-to-top d-flex align-items-center justify-content-center"
  >
    <span id="back-to-top-icon" className="material-symbols-outlined">
      arrow_upward
    </span>
  </a>
</>

  );
};

export default Footer;
